class PredictiveSearch extends HTMLElement {

  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    this.form = this.querySelector('form');

    this.slideSearch = document.querySelector('.slide_search');

    // ─────────────────────────────
    // FORM SUBMIT
    // ─────────────────────────────
    this.form.addEventListener('submit', (e) => {
      e.preventDefault();
      this.handleSubmit();
    }, true);


    // ─────────────────────────────
    // ENTER KEY
    // ─────────────────────────────
    this.input.addEventListener('keydown', (e) => {

      if (e.key === 'Enter') {
        e.preventDefault();
        this.handleSubmit();
      }

    });


    // ─────────────────────────────
    // INPUT CHANGE
    // ─────────────────────────────
    this.input.addEventListener(
      'input',
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );

  }


  // ─────────────────────────────────────────────
  // MAIN SEARCH SUBMIT
  // ─────────────────────────────────────────────
  handleSubmit() {

    const value = this.input.value.trim();

    // EMPTY SEARCH
    if (!value) {

      alert("Please enter model number or part number");

      return;
    }

    // CHECK IF RESULTS EXIST
    const items = this.querySelectorAll('#predictive-search li');

    if (!items.length) {

      alert("Please enter a valid Part Number or Model Number");

      return;
    }

    // REDIRECT TO SEARCH PAGE
    window.location.href = `/search?q=${encodeURIComponent(value)}`;

  }


  // ─────────────────────────────────────────────
  // INPUT CHANGE
  // ─────────────────────────────────────────────
  onChange() {

    const searchTerm = this.input.value.trim();

    // EMPTY INPUT
    if (!searchTerm.length) {

      this.close();

      if (this.slideSearch) {
        this.slideSearch.classList.remove('active');
      }

      return;
    }

    // OPEN SEARCH PANEL
    if (this.slideSearch) {
      this.slideSearch.classList.add('active');
    }

    this.getSearchResults(searchTerm);

  }


  // ─────────────────────────────────────────────
  // FETCH PREDICTIVE RESULTS
  // ─────────────────────────────────────────────
  getSearchResults(searchTerm) {

    fetch(`/search/suggest?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`)

      .then((response) => {

        if (!response.ok) {

          this.close();

          throw new Error(response.status);

        }

        return response.text();

      })

      .then((text) => {

        const parsedHTML = new DOMParser().parseFromString(text, 'text/html');

        const resultsContainer = parsedHTML.querySelector('#shopify-section-predictive-search');

        if (!resultsContainer) {
          this.close();
          return;
        }

        const items = resultsContainer.querySelectorAll('li');

        const searchTermLower = searchTerm.toLowerCase();

        let matchFound = false;

        items.forEach((item) => {

          const sku = (item.dataset.sku || '').toLowerCase();

          const tags = (item.dataset.tags || '').toLowerCase();

          if (
            sku.includes(searchTermLower) ||
            tags.includes(searchTermLower)
          ) {

            matchFound = true;

          } else {

            item.remove();

          }

        });


        // NO MATCH
        if (!matchFound) {

          this.predictiveSearchResults.innerHTML = `
            <div style="padding:10px; color:red;">
              Please enter a valid Part Number or Model Number
            </div>
          `;

          this.open();

        }

        // SHOW RESULTS
        else {

          this.predictiveSearchResults.innerHTML = resultsContainer.innerHTML;

          this.open();

        }

      })

      .catch((error) => {

        console.error(error);

        this.close();

      });

  }


  // ─────────────────────────────────────────────
  // OPEN RESULTS
  // ─────────────────────────────────────────────
  open() {

    if (this.predictiveSearchResults) {
      this.predictiveSearchResults.style.display = 'block';
    }

    if (this.slideSearch) {
      this.slideSearch.classList.add('active');
    }

  }


  // ─────────────────────────────────────────────
  // CLOSE RESULTS
  // ─────────────────────────────────────────────
  close() {

    if (this.predictiveSearchResults) {
      this.predictiveSearchResults.style.display = 'none';
    }

    if (this.slideSearch) {
      this.slideSearch.classList.remove('active');
    }

  }


  // ─────────────────────────────────────────────
  // DEBOUNCE
  // ─────────────────────────────────────────────
  debounce(fn, wait) {

    let t;

    return (...args) => {

      clearTimeout(t);

      t = setTimeout(() => {

        fn.apply(this, args);

      }, wait);

    };

  }

}


// ─────────────────────────────────────────────
// CUSTOM ELEMENT
// ─────────────────────────────────────────────
customElements.define('predictive-search', PredictiveSearch);